{
    "Accessibility menu": "ප්‍රවේශනීය මෙනුව",
    "Close": "වසන්න",
    "Text and Reading": "පෙළ සහ කියවීම",
    "Navigation and Interaction": "සංචලනය සහ අන්තර්ක්‍රියා",
    "Text Align": "පෙළ පෙළගැස්ම",
    "Align Left": "වමට සමපාත කරන්න",
    "Align Center": "මධ්‍යයට පෙළගස්වන්න",
    "Align Right": "දකුණට පෙළගස්වන්න",
    "Adjust Font Size": "අකුරු ප්‍රමාණය සකස් කරන්න",
    "Highlight Title": "ශීර්ෂය උද්දීපනය කරන්න",
    "Highlight Links": "සබැඳි උද්දීපනය කරන්න",
    "Readable Font": "කියවිය හැකි අකුරු",
    "Color and Contrast": "වර්ණය සහ විෂමතාව",
    "Dark Contrast": "අඳුරු කන්ට්‍රාස්ට්",
    "Light Contrast": "ලා කන්ට්‍රාස්ට්",
    "High Contrast": "ඉහළ කන්ට්‍රාස්ට්",
    "High Saturation": "ඉහළ සංතෘප්තතාවය",
    "Low Saturation": "අඩු සංතෘප්තතාවය",
    "Monochrome": "ඒකවර්ණ",
    "Tools": "මෙවලම්",
    "Reading Guide": "කියවීමේ මාර්ගෝපදේශකය",
    "Big Cursor": "විශාල කර්සරය",
    "Increase Font Size": "අකුරු ප්‍රමාණය වැඩි කරන්න",
    "Decrease Font Size": "අකුරු ප්‍රමාණය අඩු කරන්න",
    "Letter Spacing": "අකුරු අතර අවකාශය",
    "Line Height": "පේළි උස",
    "Font Weight": "අකුරු බර",
    "Dyslexia Font": "ඩිස්ලෙක්සියා අකුරු",
    "Language": "භාෂාව",
    "Accessibility widget": "ප්‍රවේශනීය මෙනුව විවෘත කරන්න",
    "Accessibility Profiles": "ප්‍රවේශනීය පැතිකඩ",
    "Cognitive Disability": "ඥානාත්මක ආබාධය",
    "Seizure Safe": "අපස්මාර ආරක්ෂිත",
    "Accessibility statement": "ප්‍රවේශනීය ප්‍රකාශනය",
    "ADHD": "ADHD",
    "Low Vision": "අඩු පෙනීම",
    "Pause Animations": "සජීවිකරණ නවත්වන්න",
    "Animation paused": "සජීවිකරණය විරාම කර ඇත",
    "Reset all settings": "සැකසුම් යළි පිහිටුවන්න",
    "Shortcut:": "කෙටිමඟ:",
    "Epilepsy Safe Mode": "අපස්මාර ආරක්ෂිත ප්‍රකාරය",
    "Mute sounds": "ශබ්ද නිහඬ කරන්න",
    "Page read": "පිටුව කියවන්න",
    "Page read controls": "පිටුව කියවීමේ පාලන",
    "Pause": "විරාමය",
    "Resume": "නැවත ආරම්භ කරන්න",
    "Stop": "නවත්වන්න",
    "Settings": "සැකසුම්",
    "Speed": "වේගය",
    "Voice": "හඬ",
    "Close accessibility menu": "ප්‍රවේශ්‍යතා මෙනුව වසන්න",
    "Back to accessibility menu": "ප්‍රවේශ්‍යතා මෙනුවට ආපසු",
    "Search languages": "භාෂා සොයන්න",
    "Selected language": "තෝරාගත් භාෂාව",
    "View accessibility statement (opens in new window)": "ප්‍රවේශ්‍යතා ප්‍රකාශය බලන්න (නව කවුළුවක විවෘත වේ)",
    "Visit CookieYes website (opens in new window)": "CookieYes වෙබ් අඩවියට පිවිසෙන්න (නව කවුළුවක විවෘත වේ)",
    "Reset all accessibility settings to default": "සියලුම ප්‍රවේශ්‍යතා සැකසුම් පෙරනිමියට යළි සකසන්න"
}
